(function registerProductDetails(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    root.TaariniProductDetails = api;
    const start = () => api.init(root.document);

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
    root.document.addEventListener('shopify:section:load', event => api.init(event.target));
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createProductDetails() {
  function animateDetails(details) {
    if (details.dataset.taDetailsMotionBound) return;
    const summary = details.querySelector('summary');
    const content = details.querySelector('.ta-product-details__content');
    if (!summary || !content) return;
    details.dataset.taDetailsMotionBound = 'true';
    let animation;
    let targetOpen = details.open;
    summary.addEventListener('click', event => {
      event.preventDefault();
      targetOpen = animation ? !targetOpen : !details.open;
      const from = details.getBoundingClientRect().height;
      if (animation) {
        animation.onfinish = null;
        animation.cancel();
      }
      const finish = () => {
        details.open = targetOpen;
        details.style.overflow = '';
        content.inert = false;
        delete details.dataset.taDetailsAnimating;
        summary.setAttribute('aria-expanded', String(targetOpen));
        if (animation) animation.cancel();
        animation = null;
      };
      if (!details.animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      details.dataset.taDetailsAnimating = 'true';
      details.open = true;
      content.inert = !targetOpen;
      summary.setAttribute('aria-expanded', String(targetOpen));
      const style = getComputedStyle(details);
      const collapsed = summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth || 0) + parseFloat(style.borderBottomWidth || 0);
      const to = targetOpen ? details.getBoundingClientRect().height : collapsed;
      details.style.overflow = 'hidden';
      // Bootstrap menu subcategories use height .35s ease. Each detail remains independent.
      animation = details.animate([{height: `${from}px`}, {height: `${to}px`}], {duration:350, easing:'ease', fill:'both'});
      animation.onfinish = finish;
    });
  }

  function init(scope) {
    scope.querySelectorAll('.ta-product-details__item').forEach(animateDetails);
  }

  return { init };
});
